<template>
  <div style="display:flex;align-items: center;">
    <div v-if="false">
      <div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type" style="flex:1;">
        <span class="ivu-input-suffix">
          <i class="ivu-icon ivu-icon-ios-search"></i>
        </span>
        <i class="ivu-icon ivu-icon-ios-loading ivu-load-loop ivu-input-icon ivu-input-icon-validate"></i>
        <input autocomplete="off" spellcheck="false" type="text" v-model="keyword" placeholder="搜索关键词" class="ivu-input ivu-input-default ivu-input-with-suffix circular" style="border-radius:32px;height:32px;">
      </div>
    </div>
    <div style="margin-left: 10px;">
      <Dropdown trigger="click" @on-click="handleChange">
        <a href="javascript:void(0)">
          <Icon size='32' type="ios-list"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem v-for="(allitem,index) in allitems" :key="'all'+index" :name='allitem.rule'>{{ allitem.text }}</DropdownItem>
          <DropdownItem v-for="(groupitem,index) in groupitems" :key="'group'+index" :name='groupitem.rule' :divided='index==0?true:false'>{{ groupitem.text }}</DropdownItem>
          <DropdownItem v-for="(sortitem,index) in sortitems" :key="'sort'+index" :name='sortitem.rule' :divided='index==0?true:false'>{{ sortitem.text }}</DropdownItem>
          <DropdownItem v-for="(filteritem,index) in filteritems" :key="'filter'+index" :name='filteritem.rule' :divided='index==0?true:false'>{{ filteritem.text }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    Opts: Object
  },
  data() {
    return {
      allitems: this.Opts.all.items,
      sortitems: this.Opts.sort.items,
      groupitems: this.Opts.group.items,
      filteritems: this.Opts.filter.items,
      selectrule: "all0",
      keyword: ""
    };
  },
  computed: {
    selectname() {
      let type = this.selectrule.match(/^[a-z|A-Z]+/gi);
      let index = this.selectrule.match(/\d+$/gi);
      return this.Opts[type].items[index].text;
    }
  },
  watch: {
    keyword: function(newVal, oldVal) {
      this.$emit("on-keyword", newVal);
    },
    selectrule: function(newVal, oldVal) {
      var type = newVal.match(/^[a-z|A-Z]+/gi);
      var index = newVal.match(/\d+$/gi);
      let value = null;

      if (type == "filter") {
        let lstCondition = [];
        let Condition = [];
        if (this.Opts[type].items[index].filterFn) {
          Condition.push(this.Opts[type].items[index].filterFn);
          lstCondition.push({ And: Condition });
        }
        value = lstCondition;
      } else {
        value = this.Opts[type].items[index];
      }
      this.$emit("on-set", type, value);
    }
  },
  methods: {
    handleChange(name) {
      let _this = this;
      _this.selectrule = name;
    }
  }
};
</script>